import { EventRecord, Material } from 'site/graphql';
import { checkAndConvertToDate } from '../date';
import { IFilterCertificatesProductForm, IFilterVideoCoursesProductForm } from './filterProductForms';

export type ISelectRecordsProductForm = { records: Pick<EventRecord, 'link' | 'date'>[] };
/**
 * Извлечение форм-итемов "Видеозапись" из массива форм
 *
 * @description Правила извлечения:
 * 1) Есть ссылка
 * 2) Если есть связь с вебинаром/семинаром, то дата начала должна наступить
 */
export const selectRecords = <T extends ISelectRecordsProductForm>(productForm: T): T['records'] => {
    return productForm.records
        .filter(record => !!record.link) // (1)
        .filter(record => record.date === null || checkAndConvertToDate(record.date) <= new Date()); // (2)
};

export type ISelectMaterialsProductForm = { materials: Pick<Material, 'link' | 'date'>[] };
/**
 * Извлечение форм-итемов "Материал" из массива форм
 *
 * @description Правила извлечения:
 * 1) Есть ссылка
 * 2) Если есть связь с вебинаром/семинаром, то дата начала должна наступить
 */
export const selectMaterials = <T extends ISelectMaterialsProductForm>(productForm: T): T['materials'] => {
    return productForm.materials
        .filter(material => !!material.link) // (1)
        .filter(material => material.date === null || checkAndConvertToDate(material.date) <= new Date()); // (2)
};

export const selectVideoCourses = <T extends IFilterVideoCoursesProductForm>(productForm: T): T['videoCourses'] => {
    return productForm.videoCourses;
};

export const selectCertificates = <T extends IFilterCertificatesProductForm>(productForm: T): T['certificates'] => {
    return productForm.certificates;
};
